/**
 * Generate a wobbly-circle SVG path centered at (0,0).
 * Returns "M ... Z" path string suitable for SVG d= or Path2D.
 *
 * @param {number} radius - average radius in user units (px in SVG)
 * @param {object} opts
 * @param {number} opts.points - number of anchor points around the circle (default 28)
 * @param {number} opts.noise  - max wobble as fraction of radius (default 0.06)
 * @param {number} opts.seed   - deterministic seed (default random)
 */
export function wobblyCirclePath(radius, opts = {}) {
  const points = opts.points ?? 28;
  const noise = opts.noise ?? 0.06;
  const seed = opts.seed ?? Math.random() * 100;
  // Small deterministic pseudo-random based on seed (sine-based)
  const rand = (i) => {
    const x = Math.sin(seed * 13.71 + i * 7.13) * 43758.5453;
    return x - Math.floor(x);
  };
  const pts = [];
  for (let i = 0; i < points; i++) {
    const a = (i / points) * Math.PI * 2;
    const wobble = 1 + (rand(i) - 0.5) * 2 * noise;
    pts.push([Math.cos(a) * radius * wobble, Math.sin(a) * radius * wobble]);
  }
  // Smooth catmull-rom-like with quadratic bezier through midpoints
  let d = "";
  for (let i = 0; i < pts.length; i++) {
    const cur = pts[i];
    const next = pts[(i + 1) % pts.length];
    const mid = [(cur[0] + next[0]) / 2, (cur[1] + next[1]) / 2];
    if (i === 0) d += `M ${mid[0].toFixed(2)} ${mid[1].toFixed(2)} `;
    const nextMid = [(next[0] + pts[(i + 2) % pts.length][0]) / 2, (next[1] + pts[(i + 2) % pts.length][1]) / 2];
    d += `Q ${next[0].toFixed(2)} ${next[1].toFixed(2)} ${nextMid[0].toFixed(2)} ${nextMid[1].toFixed(2)} `;
  }
  d += "Z";
  return d;
}
